import { Language } from '@/types';

export const LANGUAGE_TO_DATE_FORMAT: Record<Language, string> = {
  ca: 'dd/MM/yyyy',
  es: 'dd/MM/yyyy',
  eu: 'dd/MM/yyyy',
  en: 'MM/dd/yyyy',
  gl: 'MM/dd/yyyy',
};
